class ZenginBranch {
  public readonly code: string;
  public readonly name: string;
  public readonly hira: string;
  constructor({ code, name, hira }: { code: string; name: string; hira: string }) {
    this.code = code;
    this.name = name;
    this.hira = hira;
  }
  public static fromJSON = (value: any) => {
    const { code, name, hira } = Object.assign({}, value);

    if (typeof code !== 'string') throw new TypeError('.code must be a string');
    if (typeof name !== 'string') throw new TypeError('.name must be a string');
    if (typeof hira !== 'string') throw new TypeError('.hira must be a string');

    return new ZenginBranch({
      code,
      name,
      hira,
    });
  };
}

class ZenginBank {
  public readonly code: string;
  public readonly name: string;
  public readonly hira: string;
  public readonly branch?: ZenginBranch;
  constructor({ code, name, hira, branch }: { code: string; name: string; hira: string; branch?: ZenginBranch }) {
    this.code = code;
    this.name = name;
    this.hira = hira;
    this.branch = branch;
  }

  public static fromJSON = (value: any) => {
    const { code, name, hira, branch } = Object.assign({}, value);

    if (typeof code !== 'string') throw new TypeError('.code must be a string');
    if (typeof name !== 'string') throw new TypeError('.name must be a string');
    if (typeof hira !== 'string') throw new TypeError('.hira must be a string');

    return new ZenginBank({
      code,
      name,
      hira,
      branch: branch ? new ZenginBranch(branch) : undefined,
    });
  };
}

export default ZenginBank;
